import React from "react";
import SplashScreen from "./SplashScreen";

export default function NaverCallbackLoading() {
    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#F0F0EB]">
            <SplashScreen isVisible={true} />
            <p className="mt-8 text-sm font-bold text-gray-400 animate-pulse">네이버 로그인 처리 중...</p>
            <button
                onClick={() => window.close()}
                className="mt-4 px-4 py-2 bg-white/50 hover:bg-white/80 text-gray-500 text-xs rounded-full border border-gray-200 transition-all active:scale-95"
            >
                창이 닫히지 않나요? 직접 닫기
            </button>
        </div>
    );
}
